namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem5Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem5';
    }
}
